import { observer } from 'mobx-react-lite'
import Styles from './TemplatePreview.module.scss'
import { forwardRef, useState } from 'react'
import { VisualElement } from 'api/clients/VisualElementClient'
import { useObjectRef } from '@react-aria/utils'
import { getTemplatePreviewCloudinaryUrl } from 'components/Design/utils/getTemplatePreviewCloudinaryUrl'
import { useCarouselPress } from 'components/Carousel/useCarouselPress'
import { Pressable } from '@react-aria/interactions'
import cx from 'classnames'
import { Skeleton } from 'components/Skeleton/Skeleton'
import { Check03 } from 'blaze-ui/icons/16/Check03'
import { TemplatesVideoIcon } from 'components/Templates/TemplatesVidoIcon/TemplatesVideoIcon'

interface Props {
  template: VisualElement
  onPress: () => void
  itemWidth?: number
  aspectRatio: number
  isSelected?: boolean
}

export const TemplatePreview = observer(
  forwardRef<HTMLDivElement, Props>(({ template, onPress, itemWidth, aspectRatio, isSelected = false }, fRef) => {
    const ref = useObjectRef(fRef)
    const { pressProps, ...rest } = useCarouselPress({ onPress })
    const url = getTemplatePreviewCloudinaryUrl(template.preview_url, { width: itemWidth })
    const [isLoading, setIsLoading] = useState(true)

    return (
      <Pressable {...pressProps}>
        <div
          className={cx(Styles.templatePreview, { [Styles.loading]: isLoading, [Styles.selected]: isSelected })}
          ref={ref}
          {...rest}
          role="button"
          tabIndex={0}
          aria-label={`Select template: ${template.name}`}
          style={{ aspectRatio }}
        >
          {isSelected && (
            <div className={Styles.selectedCheckContainer}>
              <Check03 size={15} color="var(--light-100)" />
            </div>
          )}
          <img key={template.id} src={url} alt={template.name} onLoad={() => setIsLoading(false)} />
          {template.types.includes('video') && <TemplatesVideoIcon />}
          <Skeleton active paragraph={false} className={Styles.skeleton} />
        </div>
      </Pressable>
    )
  }),
)
